
// import merge from 'lodash.merge';

const baseTheme = (props) => {
  return {
    palette: {
      primary: {
        main: props.palette.primary.main ? props.palette.primary.main : '#3A3A3A',
        light: '#CBCBCB',
        // contrastText: '#a3a3a3',
      },
      secondary: {
        main: props.palette.secondary.main ? props.palette.secondary.main : '#E0426C',
        contrastText: props.palette.secondary.contrastText ? props.palette.secondary.contrastText : null,
      },
      sideDraw: {
        main: '#3A3A3A',
        secondary: '#E0426C',
      },
      appTopBar: {
        backgroundColor: props.palette.appTopBar ? props.palette.appTopBar.backgroundColor : null,
      },
      background: {
        default: '#CFCFCF',
      }
    },
    typography: {
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '"Open Sans"',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      title: {
        lineHeight: '1.2em',
      },
    },
    overrides: {
      MuiListItemIcon: props.listItemIcon ? {
        root: {
          color: props.listItemIcon.color,
        }
      } : {
        root: {
          color: '#3A3A3A',
        }
      },
      MuiAvatar: props.avatar ? {
        colorDefault: {
          color: props.avatar.color ? props.avatar.color : '#FFFFFF',
          backgroundColor: props.avatar.backgroundColor ? props.avatar.backgroundColor : '#3A3A3A',
        } 
      } : {
        colorDefault: {
          color: '#FFFFFF',
          backgroundColor: '#3A3A3A',
        }
      },
      MuiTabs: {
        root: {
          margin: '0 10px',
        },
      }
    }
  }
}

export default baseTheme;


// WEBPACK FOOTER //
// ./src/components/BaseTheme.js